React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_filters')
_ = require('underscore')

module.exports = class extends React.Component
  render: t.renderable ->
    { hasTeams, activeFilters, clickHandlers } = @props

    # Search is implemented as a filter but from the point of view of the ui it
    # is not one. This is enforced by the grouping of elements.
    activeFilters = _.without(activeFilters, 'search')

    t.div =>
      t.hr()

      t.div '.enterprise-filters .enterprise-button-bar', =>
        t.div '.v-centered', ->
          t.format 'filter-by'

        t.div '.options', ->
          t.b clickHandlers.team, '.option.button-link.role-button',
            class: t.classify(primary: 'teams' in activeFilters)
            disabled: !hasTeams
          , ->
            t.format 'teams'

          t.b clickHandlers.userType, '.option.button-link.role-button',
            class: t.classify(primary: 'userType' in activeFilters)
          , ->
            t.format 'user-type'

          t.b clickHandlers.hasTransferred, '.option.button-link.role-button',
            class: t.classify(primary: 'hasTransferred' in activeFilters)
          , ->
            t.format 'transferred'

        # outside of the .options div to float it separately
        t.b clickHandlers.clear, '.option.last-option.button-link.role-button.primary',
          class: t.classify(disabled: activeFilters.length == 0)
          disabled: activeFilters.length == 0
        , ->
          t.format 'clear-filters'

      t.hr()



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/filters-component.coffee